import { render } from "./AposAreaEditor.vue?vue&type=template&id=10d565f1&scoped=true"
import script from "./AposAreaEditor.vue?vue&type=script&lang=js"
export * from "./AposAreaEditor.vue?vue&type=script&lang=js"

import "./AposAreaEditor.vue?vue&type=style&index=0&id=10d565f1&lang=scss&scoped=true"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10d565f1"],['__file',"area/ui/apos/components/AposAreaEditor.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "10d565f1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('10d565f1', __exports__)) {
    api.reload('10d565f1', __exports__)
  }
  
  module.hot.accept("./AposAreaEditor.vue?vue&type=template&id=10d565f1&scoped=true", () => {
    api.rerender('10d565f1', render)
  })

}


export default __exports__